/**
 * 根据query中的key获取参数值 hash后面的不规范不处理
 * @param { string } name
 * @return { string }
 */
export function getUrlParam(name: string) {
  const url = window.location.search;
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // eslint-disable-next-line sonar/deprecation
  const res = url.substr(1).match(reg);
  if (res !== null) {
    return decodeURIComponent(res[2] || '');
  }
  return '';
}
// 把对象格式的数据转成query格式的参数
export function formatDataToQueryParams(data: any) {
  let queryStr = '?';
  const queryList = Object.entries(data || {});

  if (queryList.length == 0) {
    return '';
  }

  queryList.forEach(([key, value]) => {
    queryStr += `${key}=${value as any}&`;
  });

  return queryStr.slice(0, -1);
}

/**
 * 格式化utm_source参数
 * @param {*} params
 */
export function formatUtmSource(params: { [key: string]: any } = {}) {
  const result: string[] = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      result.push(`${key}:${params[key]}`);
    }
  }
  return encodeURIComponent(result.join('|'));
}

export function formatObject(params: { [key: string]: string | number } = {}) {
  const result: string[] = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      result.push(`${key}=${params[key]}`);
    }
  }
  return result.join(',');
}

export function getHashUrlParam(name: string) {
  const url = window.location.hash;
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // eslint-disable-next-line sonar/deprecation
  const res = url.substr(1).match(reg);
  if (res !== null) {
    return decodeURIComponent(res[2] || '');
  }
  return '';
}

// 先从url获取参数，获取不到再从hash中获取
export function getUrlAndHashParam(name: string) {
  return getUrlParam(name) || getHashUrlParam(name);
}

// 根据相关测试映射成正确的platformSource值
export function getSourceType() {
  const platformSource = +getUrlAndHashParam('platformSource');
  let sourceType: number = platformSource;
  const channelType = +getUrlAndHashParam('channelType');
  const carrierType = +getUrlAndHashParam('carrierType');
  const SOURCE_MAP: { [key: number]: number } = {
    11: 8,
    12: 9,
    21: 10,
    22: 11,
  };
  if ([1, 2].indexOf(channelType) > -1 && [1, 2].indexOf(carrierType) > -1) {
    sourceType = SOURCE_MAP[channelType * 10 + carrierType] || 1;
  }
  return sourceType;
}

/**
 * 拼接get请求参数
 */
export const formatGetParams = (params: { [key: string]: any } = {}) => {
  const result: string[] = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      result.push(`${key}=${params[key]}`);
    }
  }
  return result.join('&');
};

// 方舟链接-代运营协议
export const proxyAgreement =
  'https://fangzhou.kwaixiaodian.com/pcspa/yYXUkpWbYQVL/cTtTAQiPKick';

// 方舟链接-返佣协议
export const backAgreement =
  'https://fangzhou.kwaixiaodian.com/pcspa/wnxjMLdTyBxi/ZcJFQdKBaesv';

// 方舟链接-入驻协议
export const settleAgreement =
  'https://fangzhou.kwaixiaodian.com/kh5/aDmtrEGfMzzN/GpwTjZlHHbZo';
